(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('megafon-free-numbers', {
            parent: 'dictionary',
            url: '/megafon-free-numbers',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR', 'ROLE_MANAGER'],
                pageTitle: 'telestatApp.megafonFreeNumbers.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/megafon-free-numbers/megafon-free-numbers.html',
                    controller: 'MegafonFreeNumbersController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('megafonFreeNumbers');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('megafon-free-numbers.lock', {
            parent: 'megafon-free-numbers',
            url: '/{number}/lock',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_DIRECTOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                // RIGHTS MANAGEMENT
            }]
        })
        .state('megafon-free-numbers.sim', {
            parent: 'megafon-free-numbers',
            url: '/{number}/sim',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                // RIGHTS MANAGEMENT
            }]
        });
    }

})();
